import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Modal, Empty, StatusBadge } from "../components/ui";
import { Plus, Pencil, Trash2 } from "lucide-react";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [showNew, setShowNew] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "RESPONSABLE" });

  async function load() {
    const { data } = await api.get("/auth/users");
    setUsers(data);
  }
  useEffect(() => { load(); }, []);

  async function save() {
    if (editing) {
      const payload = { ...form }; delete payload.email;
      if (!form.password) delete payload.password;
      await api.patch(`/auth/users/${editing.id}`, payload);
    } else {
      await api.post("/auth/users", form);
    }
    setShowNew(false); setEditing(null);
    setForm({ name: "", email: "", password: "", role: "RESPONSABLE" });
    load();
  }

  async function del(id) {
    if (!window.confirm("¿Eliminar usuario?")) return;
    await api.delete(`/auth/users/${id}`);
    load();
  }

  function openNew() {
    setEditing(null);
    setForm({ name: "", email: "", password: "", role: "RESPONSABLE" });
    setShowNew(true);
  }

  function openEdit(u) {
    setEditing(u);
    setForm({ name: u.name, email: u.email, password: "", role: u.role });
    setShowNew(true);
  }

  return (
    <div>
      <div className="flex justify-end mb-3">
        <button className="btn btn-primary btn-sm" onClick={openNew} data-testid="add-user-btn"><Plus size={14} /> Nuevo Usuario</button>
      </div>

      <div className="table-wrap">
        <table className="table">
          <thead><tr><th>Nombre</th><th>Email</th><th>Rol</th><th>Status</th><th>Último acceso</th><th style={{ textAlign: "right" }}>Acciones</th></tr></thead>
          <tbody>
            {!users.length ? <tr><td colSpan={6}><Empty /></td></tr> : users.map((u) => (
              <tr key={u.id}>
                <td><b>{u.name}</b></td>
                <td className="text-xs">{u.email}</td>
                <td><span className="badge badge-blue">{u.role}</span></td>
                <td><StatusBadge value={u.status === "active" ? "Activo" : "Suspendido"} /></td>
                <td className="text-xs">{u.last_login ? new Date(u.last_login).toLocaleDateString("es-MX") : "-"}</td>
                <td style={{ textAlign: "right" }}>
                  <div className="flex gap-1 justify-end">
                    <button className="btn btn-sm" onClick={() => openEdit(u)} data-testid={`edit-user-${u.id}`}><Pencil size={12} /></button>
                    <button className="btn btn-sm btn-danger" onClick={() => del(u.id)} data-testid={`del-user-${u.id}`}><Trash2 size={12} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal open={showNew} onClose={() => setShowNew(false)} title={editing ? "Editar usuario" : "Nuevo usuario"} testId="user-modal">
        <div className="grid gap-3">
          <div><label className="label">Nombre *</label><input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="user-name" /></div>
          {!editing && <div><label className="label">Email *</label><input className="input" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="user-email" /></div>}
          <div><label className="label">Contraseña {!editing && "*"}</label><input className="input" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder={editing ? "(dejar vacío para no cambiar)" : ""} data-testid="user-password" /></div>
          <div><label className="label">Rol *</label>
            <select className="select" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} data-testid="user-role">
              <option>ADMIN</option><option>COORDINADOR</option><option>RESPONSABLE</option><option>GERENCIA</option><option>EXTERNO</option>
            </select>
          </div>
          <div className="flex justify-end gap-2 mt-3">
            <button className="btn" onClick={() => setShowNew(false)}>Cancelar</button>
            <button className="btn btn-primary" onClick={save} data-testid="user-save">{editing ? "Actualizar" : "Crear"}</button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
